import favicons from "../data/favicons";
import * as R from 'ramda'
import linkifyHtml from "linkifyjs/html";


export function addCommentNotificToLocalStograge(key){
    let commentsIds = JSON.parse(localStorage.getItem('notificCommentIds'))
    commentsIds = commentsIds ? commentsIds : []
    !(commentsIds.indexOf(key) != -1) ? commentsIds.push(key) : ''
    localStorage.setItem('notificCommentIds', JSON.stringify(commentsIds))
}

export function removeCommentNotificToLocalStograge(key){
    let commentsIds = JSON.parse(localStorage.getItem('notificCommentIds'))
    commentsIds = commentsIds ? commentsIds : []

    const index = commentsIds.indexOf(key);
    if(index != -1){
        commentsIds.splice(index, 1);
    }
    localStorage.setItem('notificCommentIds', JSON.stringify(commentsIds))

    return commentsIds
}

export function conditionCommentsTime(commentsTime, userCommentsTime, id){
    if(commentsTime[id]){
        if(!userCommentsTime || (commentsTime[id].date && !userCommentsTime[id])) {
            return true
        }
        if((commentsTime[id].date < userCommentsTime[id].date)){
            return false
        }else{
            return true
        }
    }else{
        return false
    }
}

export function conditionHistoryTime(history, user){
    console.log('user', user)
    let alertCount = 0;
    user  && history.map((data, index) => {

        let cond =  data.userId === user.id ? false : user.historyTime ? user.historyTime.date < data.time : true


        cond && alertCount ++
    })


    return alertCount
}

export function conditionLineUpdateTime(date, userLineUpdateTime = {}, id, userId, userUpdate){
    if(!date) return false
    if(!userLineUpdateTime[id]){
        if(userId !== userUpdate){
            return true
        }else{
            return false
        }
    }

    if(userLineUpdateTime[id]){
        if((userId !== userUpdate) && date > userLineUpdateTime[id].date){
            return true
        }else {
            return false
        }
    }else{
        return false
    }

}

var rp = {}
export function getCaretPos(el){
    var range=window.getSelection().getRangeAt(0);
    var sC=range.startContainer,eC=range.endContainer;

    var A=[];while(sC!==el){A.push(getNodeIndex(sC));sC=sC.parentNode}
    var B=[];while(eC!==el){B.push(getNodeIndex(eC));eC=eC.parentNode}

    rp={"sC":A,"sO":range.startOffset,"eC":B,"eO":range.endOffset};

    function getNodeIndex(n){var i=0;while(n=n.previousSibling)i++;return i}

    /*var ie = (typeof document.selection != "undefined" && document.selection.type != "Control") && true;
    var w3 = (typeof window.getSelection != "undefined") && true;
    var caretOffset = 0;
    if (w3)
    {
        var range = window.getSelection().getRangeAt(0);
        var preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(element);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        caretOffset = preCaretRange.toString().length;
    }
    else if (ie)
    {
        var textRange = document.selection.createRange();
        var preCaretTextRange = document.body.createTextRange();
        preCaretTextRange.expand(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
    }
    return caretOffset;*/
}

export function saveCaretPosition(context){
    var selection = window.getSelection();
    var range = selection.getRangeAt(0);
    range.setStart(  context, 0 );
    var len = range.toString().length;

    return function restore(){
        var pos = getTextNodeAtPosition(context, len);
        selection.removeAllRanges();
        var range = new Range();
        range.setStart(pos.node ,pos.position);
        selection.addRange(range);

    }
}

function getTextNodeAtPosition(root, index){
    var lastNode = null;

    var treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT,function next(elem) {
        if(index >= elem.textContent.length){
            index -= elem.textContent.length;
            lastNode = elem;
            return NodeFilter.FILTER_REJECT
        }
        return NodeFilter.FILTER_ACCEPT;
    });
    var c = treeWalker.nextNode();
    return {
        node: c? c: root,
        position: c? index:  0
    };
}

export function setCaretPos(el){
    el.focus();
    var sel=window.getSelection(),range=sel.getRangeAt(0);
    var x,C,sC=el,eC=el;

    C=rp.sC;x=C.length;while(x--)sC=sC.childNodes[C[x]];
    C=rp.eC;x=C.length;

    while(x--) {
        eC=eC.childNodes[C[x]];
    }

    sC = sC ? sC : 0
    if(sC.length < rp.sO){
        range.setStart(sC,rp.sO);
        range.setEnd(eC,rp.eO);
        sel.removeAllRanges();
        sel.addRange(range)
    }



    /*var charIndex = 0, range = document.createRange();
    range.setStart(el, 0);
    range.collapse(true);
    var nodeStack = [el], node, foundStart = false, stop = false;

    while (!stop && (node = nodeStack.pop())) {
        if (node.nodeType == 3) {
            var nextCharIndex = charIndex + node.length;
            if (!foundStart && sPos >= charIndex && sPos <= nextCharIndex) {
                range.setStart(node, sPos - charIndex);
                foundStart = true;
            }
            if (foundStart && sPos >= charIndex && sPos <= nextCharIndex) {
                range.setEnd(node, sPos - charIndex);
                stop = true;
            }
            charIndex = nextCharIndex;
        } else {
            var i = node.childNodes.length;
            while (i--) {
                nodeStack.push(node.childNodes[i]);
            }
        }
    }
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);*/
}

export function getLinkFromText(text){
    let textNotLink = text.replace(/<\/?a[^>]*>/gim, "")
    //let textNotLink = text


    let html = linkifyHtml(textNotLink, {
        defaultProtocol: 'https',
        linkClass: 'link',
        attributes: href => {
            return {
                'onClick': 'window.open(this.href,\'_blank\'); return false;'
            }
        }
    });




    return html
}

export function setLocalStorageTitle(key, title){
    let lists = localStorage.getItem('lists');
    lists = lists ? JSON.parse(lists) : {};
    const list = {
        key,
        title:title
    }
    lists[key] = list
    localStorage.setItem('lists', JSON.stringify(lists));
}

export function setLocalStorage(keyList, key, data){
    let listSettings = localStorage.getItem('listAttr');
    listSettings = listSettings ? JSON.parse(listSettings) : {};
    let tempKey = listSettings[keyList] ? listSettings[keyList][key] : {}
    const list = {
        keyList,
        [key]: {...tempKey, [data.label] : data.val}
    }
    console.log(keyList)
    listSettings[keyList] = list
    localStorage.setItem('listAttr', JSON.stringify(listSettings));
}

export function getLocalStorage(key, keyList){
    let listSettings = localStorage.getItem('listAttr');
    listSettings = listSettings ? JSON.parse(listSettings) : {};

    let returnData = listSettings[keyList] ? listSettings[keyList][key] : {}

    return  returnData
}

export function getShortText(text, count,  dots){
    let shortText = `${R.take(count, text ? text : '')}`
    if(dots){
        shortText += '...'
    }


    return  shortText
}

export function removeHtml(text){

    return  text.replace(/<\/?[^>]+>/g,'')
}

export function debounce(fn, interval){
    let timer;
    return function debounced() {
        clearTimeout(timer);
        let args = arguments;
        let that = this;
        timer = setTimeout(function callOriginalFn() {
            fn.apply(that, args);
        }, interval);
    };
}


// WEBPACK FOOTER //
// ./src/functions/snippets.js